import { BaseModel } from "@/store/feathers/feathers.client.js";

export default class SchedulesPayments extends BaseModel {
  constructor(data, options) {
    super(data, options);
  }

  static modelName = "SchedulesPayments";

  // eslint-disable-next-line no-unused-vars
  static instanceDefaults(data, { models, store }) {
    return {
      app_id: store.state.ids.app_id,
      tenant_id: store.state.ids.tenant_id,
      developer_id: store.state.ids.developer_id,
      reseller_id: store.state.ids.reseller_id,
      merchant_id: store.state.ids.merchant_id,
      created_by_id: store.state.ids.user_id,
      updated_by_id: store.state.ids.user_id,
    }
  }

  // eslint-disable-next-line no-unused-vars
  static setupInstance(data, { models, store }) {
    if (data.transaction) {
      data.transaction = new models.api.Transactions(data.transaction);
    }
    if (data.schedule) {
      data.schedule = new models.api.Schedules(data.schedule);
    }

    // if (data.subscriptions && data.subscriptions.length > 0) {
    //   data.subscriptions.map(async (subscriptions) => {
    //     subscriptions = new models.api.Subscriptions(subscriptions);
    //   });
    // }

    return data;
  }
}
